<template>
  <el-container>
    <el-header class="table-header">
      <el-button type="primary" size="small" @click="submit">{{$t('common.Save')}}</el-button>
    </el-header>
    <el-main class="table-main">
      <el-form :model="form" size="mini" label-width="80px" :rules="CommitForm" ref="form" class="table-form">
        <el-row :gutter="20">
          <el-divider content-position="left">{{$t('base.info.dict.DictionaryType')}}</el-divider>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.dict.DictionaryTypeCode')" prop="code" label-width="50px">
              <el-input v-model="form.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.dict.DictionaryTypeName')" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Type')" prop="type">
              <el-select v-model="form.type" size="mini">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.SystemName')" prop="systemId">
              <el-select v-model="form.systemId" :placeholder="$t('common.PleaseChoose')" size="mini">
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.Remark')" prop="remark" label-width="50px">
              <el-input type="textarea" size="mini" v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.Status')" prop="status">
              <template>
                <el-radio-group v-model="form.status">
                  <el-radio :label="30">{{$t('common.Normal')}}</el-radio>
                  <el-radio :label="50">{{$t('common.Disable')}}</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider content-position="left">{{$t('base.info.dict.DictInfoList')}}</el-divider>
      <header class='mt-20'>
        <el-button style="float: right;" icon="el-icon-plus" class="btn" size="mini" @click="addItem">{{$t('common.Add')}}</el-button>
      </header>
      <el-form :model="formData" ref="formMain">
        <el-table
          :data="formData.tableData"
          border stripe style="width: 100%"
          height="370px">
          <el-table-column
            align="center"
            prop="code"
            width="160%"
            :label="$t('common.Code')">
            <template slot-scope="scope">
              <el-input v-model="scope.row.codeId" v-show="false" size="mini"></el-input>
              <el-form-item :prop="'tableData.' + scope.$index + '.code'" :rules='CommitForm2.code' >
                <el-input v-model="scope.row.code" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="type"
            width="140%"
            :label="$t('common.Type')">
            <template slot-scope="scope">
              <el-input v-model="scope.row.typeId" v-show="false" size="mini"></el-input>
              <el-form-item :prop="'tableData.' + scope.$index + '.type'" :rules='CommitForm2.type' >
                <el-select v-model="scope.row.type" size="mini">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            width="180%"
            :label="$t('common.Name')">
            <template slot-scope="scope">
              <el-input v-model="scope.row.nameId" v-show="false" size="mini"></el-input>
              <el-form-item :prop="'tableData.' + scope.$index + '.name'" :rules='CommitForm2.name' >
                <el-input v-model="scope.row.name" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="value"
            width="100%"
            :label="$t('common.Value')">
            <template slot-scope="scope">
              <el-input v-model="scope.row.valueId" v-show="false" size="mini"></el-input>
              <el-input v-model="scope.row.value" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="remark"
            width="200%"
            :label="$t('common.Remark')">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remarkId" v-show="false" size="mini"></el-input>
              <el-form-item :prop="'tableData.' + scope.$index + '.remark'" :rules='CommitForm2.remark' >
                <el-input size="mini" v-model="scope.row.remark"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            prop="beginDay"
            :formatter="dataFormat"
            :label="$t('common.StartDay')"
            align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.beginDayId" v-show="false" size="mini"></el-input>
              <el-date-picker
                v-model="scope.row.beginDay" style="width: 90%"
                type="date" size="mini">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            prop="endDay"
            :formatter="dataFormat"
            :label="$t('common.EndDay')"
            align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.endDayId" v-show="false" size="mini"></el-input>
              <el-date-picker
                v-model="scope.row.endDay" style="width: 90%"
                type="date" size="mini">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="isEffective"
            :label="$t('common.Valid')"
            width="80%">
            <template slot-scope="scope">
              <!--<el-input v-model="scope.row.statusId" v-show="false" size="mini"></el-input>-->
              <el-checkbox v-model="scope.row.isEffective" true-label="true" false-label="false"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="operation"
            :label="$t('common.Operate')"
            width="100%">
            <template slot-scope="scope">
              <el-input v-model="scope.row.operationId" v-show="false" size="mini"></el-input>
              <el-button
                size="mini"
                type="text"
                @click="deleteItem(scope.$index, scope.row)">{{$t('common.Delete')}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      form: {
        status: 30
      },
      formData: {
        tableData: []
      },
      options: [{
        value: 10,
        label: '自定义'
      }, {
        value: 80,
        label: '系统默认'
      }],
      options2: [],
      tableData: []
    }
  },
  methods: {
    addItem () {
      this.formData.tableData.push({
        code: null,
        type: null,
        value: null,
        name: null,
        dateValue: null,
        isEffective: true,
        remark: null,
        status: null
      })
    },
    dataFormat () {
      let tableTemp = this.tableData
      for (let i = 0; i < tableTemp.length; i++) {
        if (tableTemp[i].isEffective === 'true') {
          tableTemp[i].status = 50
        } else {
          tableTemp[i].status = 30
        }
        let date1 = tableTemp[i].beginDay
        let date2 = tableTemp[i].endDay
        if (date1 === undefined) {
          tableTemp[i].beginDay = ''
        }
        if (date2 === undefined) {
          tableTemp[i].endDay = ''
        }
        tableTemp[i].beginDay = moment(date1).valueOf()
        tableTemp[i].endDay = moment(date2).valueOf()
      }
      this.tableData = tableTemp
    },
    submit () {
      this.dataFormat()
      this.$refs.form.validate(valid2 => {
        if (valid2) {
          this.$refs['formMain'].validate(valid => {
            if (valid) {
              let param = {
                data: {codeTypeInsertReq: this.form, codeInfoInsertReqs: this.formData.tableData}
              }
              this.$api.dictionary.dictInsert(param)
                .then((response) => {
                  this.$router.push({path: '/dictionaryList'})
                  let tabItem = this.$store.getters.rightNav
                  this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
                  if (response.data.status === 'Y') {
                    this.$message({
                      message: response.data.message,
                      type: 'success'
                    })
                  } else {
                    this.$message({
                      message: response.data.message,
                      type: 'error'
                    })
                  }
                }).catch((error) => {
                  console.log(error)
                })
            }
          })
        }
      })
    },
    initSysData () {
      this.$api.systemList.systemSelect().then((response) => {
        response.data.data.map((value, i) => {
          this.options2.push({label: value.name, value: value.id})
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    deleteItem (index, row) {
      this.formData.tableData.splice(index, 1)
    },
    message () {
      const h = this.$createElement
      this.$notify({
        title: '提示',
        message: h('i', {style: 'color: teal'}, ''),
        duration: 6000
      })
    }
  },
  computed: {
    CommitForm () {
      return {
        name: [{required: true, trigger: 'blur', message: this.$t('base.info.dict.CanNotBeEmpty')}],
        code: [{required: true, trigger: 'blur', message: this.$t('base.info.dict.CanNotBeEmpty')}],
        type: [{required: true, trigger: 'change', message: this.$t('base.info.dict.TypeSelect')}],
        remark: [{max: 90, message: this.$t('base.info.dict.LengthTips')}]
      }
    },
    CommitForm2 () {
      return {
        name: [{required: true, trigger: 'blur', message: ' '}],
        code: [{required: true, trigger: 'blur', message: ' '}],
        type: [{required: true, trigger: 'change', message: ' '}],
        remark: [{max: 90, message: ''}]
      }
    }
  },
  created () {
    this.initSysData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/dictionary/addDictionary.vue